import React, { useState } from 'react';
import './CustomModal.css';
import Swal from 'sweetalert2';

function DesignChangeModal({ isOpen, onClose, onSave }) {
  const [amount, setAmount] = useState('');
  const [date, setDate] = useState('');

  if (!isOpen) {
    return null;
  }

  const handleSave = () => {
    if (!amount || Number(amount) <= 0) {
      Swal.fire({
        icon: 'error',
        title: '입력 오류',
        text: '유효한 변경 금액을 입력해주세요.',
      });
      return;
    }

    if (!date) {
      Swal.fire({
        icon: 'error',
        title: '입력 오류',
        text: '변경일을 입력해주세요.',
      });
      return;
    }

    onSave({ amount, date });
  };

  return (
    <div className="custom-modal-overlay" onClick={onClose}>
      <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="custom-modal-close-button" onClick={onClose}>×</button>
        <h2>설계변경</h2>
        <div className="form-group">
          <label>변경 금액</label>
          <input
            type="text"
            className="form-control"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="변경될 계약금액을 입력하세요"
          />
        </div>
        <div className="form-group">
          <label>변경일</label>
          <input
            type="date"
            className="form-control"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </div>
        <div className="custom-modal-actions">
          <button onClick={handleSave} className="custom-modal-button save">저장</button>
          <button onClick={onClose} className="custom-modal-button cancel">취소</button>
        </div>
      </div>
    </div>
  );
}

export default DesignChangeModal;
